module.exports = {
	'shift.hp.m3.m310410_inspection.group_config_dialog': {
		'selectAGroupClass': 'select a group class',
		'selectALabel': 'Label',
	},
	'shift.hp.m3.m310410_inspection.inspect_config': {
		'selectedClass': 'Shifts selected',
		'theFileFormatIsIncorrect': 'file format is incorrect',
		'postsShouldBeRearrangedForManpower': 'Import Staffing for the Position',
	},
	'shift.m4.m410210': {
		'saveAndSubmitSchedules': 'Save and submit',
		'scheduleStatus': 'Shift status',
		'previewStatus': 'Pre-scheduling status'
	},
	'shift.am.Shifting': {
		'workingHours': 'Work time',
		'breaks': 'Rest time',
	},
	'shift.am.ShiftingFieldSetting': {
		'theNumberOfBlockedColumnsCannot': 'Frozen columns cannot exceed 10.',
		'open': 'on',
		'theLeftSideFreezes': 'left side freezes',
		'theRightSideFreezes': 'right side freezes',
	},
	'ai-shift.m3.m310410_ai_shift.dialog': {
		'manpowerAllocation': 'Resource Allocation',
		'staffScheduling': 'Employee pre-scheduling',
		'generatingYourScheduleData': 'Generating your schedule now...',
		'byUnderstandingYourSchedulingConsiderationsI': 'By understanding your scheduling considerations, I can generate shifts quickly. Could you please share your considerations with me?',
		'aISchedulingConsiderations': 'AI Scheduling Considerations',
		'minimumCost': 'Lowest cost',
		'averageWorkingHours': 'Average working hours',
		'mustMeetTheRequirements': 'Required Conditions',
		'startGeneratingTheSchedule': 'Start generating schedule',
		'downloadGeneratedResults': 'Download Results',
		'workingHoursRegulations': 'Schedule check result',
		'employeeManagement': 'Employee management',
		'humanResourceAllocation2': 'Resource allocation',
		'workingHoursRegulationsHint': 'Optional, but recommended: check it so the AI applies schedule check rules while building the schedule. Even if you leave it unchecked, the system re-checks the schedule check rules when you save the schedule.',
		'aISchedulingBasisAndDataUsageScope': 'What the schedule is based on & how your data is used',
		'schedulingIsBasedOnlyOnResourceAllocation': "Scheduling uses only resource allocation, employees' available working times, tags, working-hours rules and pre-scheduling. It never collects or uses the reasons behind someone's availability (such as pregnancy, religion, health or family-care needs) as a basis for scheduling.",
	},
	'ai-shift.m3.m310410_ai_shift.resource_allocation': {
		'editManpowerAllocation': 'Edit resource allocation',
		'queryManpowerAllocation': 'View resource allocation',
		'yYYYMMDD': 'YYYY/MM/DD',
		'person': 'staff',
	},
	'ai-shift.m3.m310410_new': {
		'aIHelpsYouScheduleShifts': 'AI Schedule Helper',
		'rescheduleAIShifts': 'Re-schedule with AI',
		'differenceDate': 'Difference Dates',
	},
	'ai-shift.m3.m310410_shifting': {
		'whyGenerateThisScheduleForYou': 'This schedule has been automatically generated in accordance with your specified parameters.',
		'basedOnYourSchedulingConsiderationsFor': 'It is optimized to satisfy your requirements through the integration of Employee management, Resource allocation, Schedule check result, and Employee pre-scheduling.\nOur commitment is to maintain a scheduling process that is equitable and in full compliance with applicable legal standards.',
	},
	'ai-shift.m3.m310320_grid': {
		'theDataHasBeenDeletedAnd': 'Deleted data cannot be saved.',
		'overnightShiftsOnlyDisplayTheCurrent': 'Overnight shifts show current day only; AI scheduling uses full duration.',
		'forShiftsThatSpanOvernightE': 'For overnight shifts (e.g., 20:00 yesterday to 04:00 today), only the portion falling within the current day (00:00 - 04:00) will be displayed. Rest assured, AI auto-scheduling still calculates based on the full shift duration, ensuring actual results remain unaffected.',
	},
	'ai-shift.m3.m310320': {
		'groupsCannotBeDuplicated': 'No group conflict is allowed.',
	},
	'ai-shift.service.m3.service-m310320': {
		'theCurrentlySelectedClassIsNo': 'The currently selected <%=temp1%> is no longer applicable. Please select a valid shift and save.',
	},
	'ai-shift.service.m3.service-m310410-ai-shift': {
		'whenTheNumberOfScheduledPersonnel': 'To ensure scheduling efficiency and optimal results, the direct use of the AI auto-scheduling feature is temporarily not recommended for teams exceeding 100 people.',
		'beforeAIHelpsYouScheduleYou': 'Before the AI can help you schedule shifts, please set up your staffing requirements first.\nGo to the Resource Allocation settings and enter the required number of people for at least one day.',
		'insufficientManpowerToScheduleShiftsPlease': 'Not enough manpower to make the schedule.\nPlease adjust the resource allocation.',
		'lackingEmployeesWith': 'Lacking staff with <%=temp1%>',
		'aSystemEnvironmentErrorHasOccurred': 'A system environment error occurred. Please contact a 104 HR Max FAE engineer.',
	},
	'ai-shift.m3.m310410_ai_shift.compare': {
		'datesWithDifferencesBetweenAIScheduling': 'Dates with discrepancies between AI scheduling and resource allocation',
	},
};
